export default __webpack_public_path__ + "locales/ru/Settings.json?hash=273acf039781fb9991835e02bec4a124";